import React from 'react'
import { AddButtonTransparent } from '@routes/IconeSvg'

export default function ButtonAddCard({
    title,
    onClick
}){
    return(
        <div className='arh-bg-greyColor arh-px-3 arh-py-2 arh-flex arh-items-center arh-justify-between'>
            <span className='arh-font-poppins arh-font-normal arh-text-darkColor arh-text-xs'>{title}</span>
            <button
                className={`arh-flex arh-justify-center arh-items-center arh-border-white arh-border-[2px] arh-border-solid arh-rounded-full arh-transition-all arh-duration-200 arh-ease-in disabled:arh-bg-greyDisabled arh-bg-greenColor hover:arh-bg-darkGreenColor arh-w-6 arh-h-6`}
                onClick={onClick}
            >
                 {AddButtonTransparent()}
            </button>
        </div>
    )
}